import React from 'react';
import { useDispatch } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { isNull, isUndefined } from 'lodash';
import { Formik, FormikHelpers } from 'formik';

import { Loading, LoadingError } from '@components/Base';
import { useIsRequired } from '@hooks/yup';
import { OrderStatuses } from '@models/Order';

import CorporateHealthQuoteForm, { FormDisabled, FormRequired, FormValues } from '../CorporateHealthQuoteBuyForm';
import { CorporateHealthQuoteUpdatePayload, corporateHealthQuoteUpdate } from '../action';
import { useCorporateHealthQuoteFetch } from '../hook';
import { useValidationSchema, useInitialValues } from './hook';

const CorporateHealthQuoteBuyEditPage = () => {
  const dispatch = useDispatch();
  const corporateHealthQuote = useCorporateHealthQuoteFetch();
  const initialValues = useInitialValues(corporateHealthQuote);
  const validationSchema = useValidationSchema();
  const required = useIsRequired<FormRequired>(validationSchema);

  if (isUndefined(corporateHealthQuote)) return <Loading />;
  if (isNull(corporateHealthQuote)) return <LoadingError />;
  if (!initialValues) return null;

  const { orderNumber, status } = corporateHealthQuote;
  const isLocked = status === OrderStatuses.Locked;
  const isActive = status === OrderStatuses.Active;
  const disabled: FormDisabled = {
    insurerId: true,
    healthPlanId: true,
    userId: true,
    activationDate: isLocked || isActive,
    adminFeeAmount: isLocked || isActive,
    note: isLocked || isActive,
    proof: isLocked || isActive,
  }

  const handleSubmit = (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    const payload: CorporateHealthQuoteUpdatePayload = { orderNumber, ...values };
    dispatch(corporateHealthQuoteUpdate(payload));
    setSubmitting(false);
  };

  return (
    <Container className="my-3">
      <Row className="gy-5">
        <Col lg={8}>
          <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
            <CorporateHealthQuoteForm required={required} disabled={disabled} />
          </Formik>
        </Col>
      </Row>
    </Container>
  );
};

export { CorporateHealthQuoteBuyEditPage };
